export default __webpack_public_path__ + "502c06a1c50b0f0a3bdaa86eca92a1e7.png";